<template>
  <div class="donut-wrapper">
    <apexchart width="100%" height="100%" type="donut" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
export default {
  name: "DonutChart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      options: {
        dataLabels: {
          enabled: false
        },
        labels: this.labels,
        plotOptions: {
          pie: {
            customScale: 0.8,
            donut: {
              size: '85%',
            }
          }
        },
        legend: {
        // show: false,
        position: 'bottom',
      },
      },
    };
  },
};
</script>
<style scoped>
.donut-wrapper{
  height: 100%;
}
</style>